/**
 * proposalCatalog.js — shared formatting helpers & configuration option lists.
 * Product prices and rates now come from the database, so this file only
 * keeps UI-level constants (option arrays, formatters).
 */

// ─── Configuration Options ─────────────────────────────────
export const LICENSE_TYPES = [
  { value: 'PRO',   label: 'PRO' },
  { value: 'BASIC', label: 'BÁSICA' },
];

export const MAINTENANCE_TYPES = [
  { value: 'ESTANDAR', label: 'ESTÁNDAR' },
  { value: 'PREMIUM',  label: 'PREMIUM' },
];

export const ZONES = [
  { value: 'ZONA_I',   label: 'ZONA I - España Peninsular, Portugal, Baleares' },
  { value: 'ZONA_II',  label: 'ZONA II - Islas Canarias, Francia, Italia, Alemania' },
  { value: 'ZONA_III', label: 'ZONA III - Resto de Europa' },
  { value: 'ZONA_IV',  label: 'ZONA IV - América, Asia, Oceanía' },
];

export const LOCKER_RANGES = [
  { value: '0-500', label: '0 - 500' },
  { value: '501-1000', label: '501 - 1000' },
  { value: '1001-2000', label: '1001 - 2000' },
];

export const INSTALLATION_TYPES = [
  { value: 'interior', label: 'Interior (CDF)' },
  { value: 'exterior', label: 'Exterior (INOX + HPL)' },
];

export const LOCK_TYPES = [
  { value: 'STANDARD', label: 'Standard' },
  { value: 'BLUETOOTH', label: 'Bluetooth' },
];

export const SALE_MODES = [
  { value: 'purchase', label: 'Compra' },
  { value: 'rental', label: 'Alquiler' },
  { value: 'revenue_share', label: 'Revenue Share' },
];

// ─── Formatting Helpers ────────────────────────────────────
export const fmt = (n) => {
  if (n === 0) return '-';
  return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
};

export const fmtAlways = (n) => {
  return n.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
};

export const fmtPct = (n) => {
  return n.toFixed(2) + '%';
};
